module.exports = __webpack_public_path__ + "img/vertical_4_4_8017.58c6566c.png";